import { faSyringe } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PetExpiredVaccines } from '@spike/pet-model';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import styles from './PetStatusIndicators.module.scss';

interface PetStatusIndicatorsProps {
    petId: number;
    petName: string;
}

export const PetStatusIndicators: FunctionComponent<PetStatusIndicatorsProps> = props => {
    const expiredVaccines = useSelector<RootState, PetExpiredVaccines | undefined>(state =>
        state.pets.expiredVaccines.find(pet => pet.petId === props.petId)
    );
    const expiredVaccinesQuantity = expiredVaccines?.expiredVaccines.length ?? 0;

    return (
        <div className={styles.container}>
            {expiredVaccinesQuantity > 0 && (
                <Tooltip
                    content={
                        <div className={styles.tooltipContent}>
                            <span className={styles.tooltipTitle}>Expired Vaccines</span>
                            <span>
                                {props.petName} has <strong>{expiredVaccinesQuantity}</strong> expired vaccines
                            </span>
                        </div>
                    }
                    className={styles.tooltip}
                >
                    <FontAwesomeIcon
                        icon={faSyringe}
                        className={styles.expiredVaccinesIcon}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default PetStatusIndicators;
